const ServingAdjuster = ({
  value,
  onChange,
  label,
  showUnit = false,
  showServings = true,
  unitLabel = "oz",
  step = 0.5,
  readOnlyInput = true,
}) => {
  const currentValue = value;
  const handleChange = (delta) => {
    const updated = Math.max(step, currentValue + delta);
    if (typeof onChange === "function") {
      onChange(updated);
    }
  };

  return (
    <div className="tw-flex tw-flex-col tw-gap-1">
      {label && (
        <label className="tw-block tw-text-sm tw-font-medium">{label}</label>
      )}
      <div className="tw-flex tw-items-center">
        <button
          type="button"
          className="hover:tw-bg-gray-100 tw-h-full tw-min-w-[44px] tw-min-h-[44px] tw-rounded-lg"
          onClick={() => handleChange(-step)}
        >
          –
        </button>
        <div className="tw-flex tw-items-center tw-flex-col tw-relative tw-justify-center tw-gap-2">
          <input
            type="number"
            step={step}
            min={step}
            className="tw-border-none tw-pl-3 tw-flex tw-items-center tw-justify-center tw-text-center tw-min-w-[40px] tw-max-w-[50px] tw-bg-transparent tw-min-w-[42px] dark:tw-bg-black tw-min-h-[50px]"
            value={currentValue}
            readOnly={readOnlyInput}
            style={{
              WebkitAppearance: "none",
              MozAppearance: "textfield",
            }}
          />
        </div>
        <button
          type="button"
          className="hover:tw-bg-gray-100 tw-h-full tw-min-w-[44px] tw-min-h-[44px] tw-rounded-lg"
          onClick={() => handleChange(step)}
        >
          +
        </button>
        {showUnit && (
          <span className="tw-text-gray-500 tw-text-xs">{unitLabel}</span>
        )}
      </div>
    </div>
  );
};

export default ServingAdjuster;
